@if (accessGranted) {
    @if (displayBehaviour !== "inline") {
        @if (creationInfo) {
            <p-dialog
                [(visible)]="dialogVisible"
                (onHide)="onCancelProblemCase()"
                [header]="
                    'cs.psv.problemcase.dialogHeader'
                        | hisUi
                            : (buttonText | hisUi)
                            : creationInfo.problemCaseDefaulttext
                "
                [modal]="true"
            >
                <his-send-problem-case-form
                    #formComponent
                    [infotext]="creationInfo.infotext"
                    [senderEmails]="senderEmails"
                    [initialSenderEmail]="
                        senderEmails ? senderEmails[0] : undefined
                    "
                    [recipientsVisible]="recipientsVisible"
                    [recipientsEditable]="recipientsEditable"
                    [recipients]="findAllRecipients()"
                    [initialRecipients]="creationInfo.recipients"
                    [subjectVisible]="creationInfo.subjectVisible"
                    [initialSubject]="creationInfo.problemCase.subject"
                    [initialContent]="creationInfo.problemCase.content"
                    [contextInformation]="creationInfo.contextInformation"
                    [disabled]="disableForm"
                    (submitProblemCaseForm)="onSubmitProblemCase($event)"
                    (cancelProblemCaseFrom)="onCancelProblemCase()"
                />
            </p-dialog>
        }

        <button
            type="button"
            [hisImage]="buttonIcon"
            [ngClass]="buttonClass"
            (click)="onShowDialog()"
        >
            @if (buttonText) {
                {{ buttonText | hisUi }}
            }</button
        >&nbsp;<!-- hack to prevent icon from being hidden -->
    } @else {
        @if (creationInfo) {
            @if (showSuccess) {
                <div
                    ngClass="successMessage"
                    [innerHTML]="inlineSuccessMessageKey | hisUi"
                ></div>
            } @else {
                <his-send-problem-case-form
                    #formComponent
                    [infotext]="creationInfo.infotext"
                    [senderEmails]="senderEmails"
                    [initialSenderEmail]="
                        senderEmails ? senderEmails[0] : undefined
                    "
                    [recipientsVisible]="recipientsVisible"
                    [recipientsEditable]="recipientsEditable"
                    [initialRecipients]="creationInfo.recipients"
                    [recipients]="findAllRecipients()"
                    [subjectVisible]="creationInfo.subjectVisible"
                    [initialSubject]="creationInfo.problemCase.subject"
                    [initialContent]="creationInfo.problemCase.content"
                    [contextInformation]="creationInfo.contextInformation"
                    [showCancelButton]="showCancelButton"
                    [disabled]="disableForm"
                    (submitProblemCaseForm)="onSubmitProblemCase($event)"
                    (cancelProblemCaseFrom)="onCancelProblemCase()"
                />
            }
        }
    }
}
